import type { PropsWithChildren } from 'react';

import { type IOverLayLoaderProps, OverlayLoader } from './OverlayLoader'

export const WithOverlayLoader = ({
  children,
  visible = false,
  ...otherProps
}: PropsWithChildren<IOverLayLoaderProps>) => {
  return (
    <div style={{ position: 'relative' }}>
      {children}
      <OverlayLoader visible={visible} {...otherProps} />
    </div>
  )
}
